'use strict'; // Expose module API:

module.exports.polynomial = require('./polynomial.js');
module.exports.linear = require('./linear.js');
module.exports.linearRegression = require('./linearRegression.js');
module.exports.step = require('./step.js');